(function () {
  var countElement = document.querySelector('[data-co-collection-count]');
  var results = document.querySelector('[data-co-collection-results]');

  if (!countElement || !results || !window.MutationObserver) return;

  function updateCount() {
    var productList = results.querySelector('.boost-sd__product-list[data-total-product]');
    var rawCount = productList ? productList.getAttribute('data-total-product') : null;
    if (!productList && results.querySelector('.boost-sd__product-list-pagination-in-collection-search-empty-message')) {
      rawCount = '0';
    }

    if (rawCount === null || !/^\d+$/.test(rawCount)) return;

    var count = Number(rawCount);
    if (!Number.isSafeInteger(count)) return;

    var template = countElement.getAttribute(count === 1 ? 'data-count-one' : 'data-count-other');
    if (!template) return;

    var text = template.replace(/__COUNT__/g, count.toLocaleString(document.documentElement.lang || 'en-AU'));
    if (countElement.textContent.trim() !== text) countElement.textContent = text;
  }

  updateCount();
  new MutationObserver(updateCount).observe(results, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-total-product']
  });
})();
